module.exports = __webpack_public_path__ + "static/ceremony-vert-0ccd9dd2d0e07f9c857bdc581b696f37.jpg";